import type { CalendarDate, Time } from "@internationalized/date";

import { PLATFORM_PUBLISH_RULES } from "@nlc/shared-types";
import { Delta } from "quill";

import type { Platform } from "./post-type-step/postTypes";

export type GoLiveMode = "later" | "now";

export interface ScheduleDraft {
  caption: Delta;
  date: CalendarDate | null;
  goLive: GoLiveMode;
  name: string;
  time: null | Time;
}

export function emptyScheduleDraft(): ScheduleDraft {
  return {
    caption: new Delta(),
    date: null,
    goLive: "later",
    name: "",
    time: null,
  };
}

export function captionText(caption: Delta): string {
  return caption.ops
    .map((op) => (typeof op.insert === "string" ? op.insert : ""))
    .join("")
    .trim();
}

export function captionMaxLength(platform: Platform): number {
  return PLATFORM_PUBLISH_RULES[platform]?.captionMax ?? 0;
}
